<ng-container *ngIf="iconUrl; else generatedIcon">
  <div class="container">
    <img
      [ngClass]="{ shadow: shadow }"
      [ngStyle]="getHeightStyle()"
      class="lb-lst-source-name-icon"
      src="{{ iconUrl }}"
      (error)="getDefaultProfileImage()"
      alt="{{ name }}"
    />
    <div [ngStyle]="getIconSize()" class="ecosystem" *ngIf="ecosystemSources > 0">
      <div class="ecosystem--text">+{{ ecosystemSources }}</div>
    </div>
  </div>
</ng-container>

<ng-template #generatedIcon>
  <div class="va-icon-with-margin">
    <va-icon [iconName]="name" [diameter]="36"></va-icon>
  </div>
</ng-template>
